import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { DateAdapter } from '@angular/material/core';

import { enGB, nb } from 'date-fns/locale';

import { TranslateService } from '@ngx-translate/core';

import { LanguageEnum, LanguageService } from '@gan/core/feature-language';

@Component({
  selector: 'gan-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatRadioGroup, MatRadioButton]
})
export class LanguageSwitcherComponent {
  private translateService = inject(TranslateService);
  private languageService = inject(LanguageService);
  private dateAdapter = inject(DateAdapter<Date>);

  selectedLanguage = this.languageService.getLang();

  languageEnum = LanguageEnum;

  /**
   * change language
   * @param lang - selected language
   */
  onChangeLanguage(lang: LanguageEnum) {
    this.translateService.use(lang);
    this.languageService.setLang(lang);
    this.dateAdapter.setLocale(lang === LanguageEnum.EN ? enGB : nb);
  }
}
